import PropTypes from "prop-types";
import React from 'react'


const SEO = ( {title} ) => {
    return (
        <>
            <meta charSet="utf-8" />
            <title>{title}BlueSparrow Token</title>
            <meta name="robots" content="noindex, follow" />
            <meta name="description" content="The BlueSparrow token is the official native token to BlueBit.io which offers full MT5 Forex, Commodities, Stocks, Indices, and Margin Trading, including iOS app and its very own NFT Marketplace." />
            <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
        </>
    )
}
SEO.propTypes = {
    title: PropTypes.string
};

export default SEO;


